import { useRoute } from 'wouter-preact'
import { useEffect } from 'preact/hooks'

import { DropdownButton, PlusIcon } from 'components/UI'
import {
	isNewSmartContractModalOpen,
	setSmartContractModalState
} from 'pages/home/state'
import { projectDetailsState } from 'state'
import { NewSmartContractModal } from 'pages/components'

const SmartContractMenu = () => {
	const [isOnSettingsPage] = useRoute('/settings')
	const [isOnWorkspacePage] = useRoute('/smart-contract/:dAppName/workspace')

	useEffect(
		() => () => {
			setSmartContractModalState(false)
		},
		[]
	)

	const isDAppReadOnly = isOnWorkspacePage || isOnSettingsPage
	const defaultDAppName =
		isDAppReadOnly && projectDetailsState.value
			? {
					id: projectDetailsState.value.publicId,
					name: projectDetailsState.value.name
				}
			: undefined

	return (
		<>
			<DropdownButton onClick={() => setSmartContractModalState(true)}>
				<PlusIcon />
			</DropdownButton>

			{isNewSmartContractModalOpen.value && (
				<NewSmartContractModal
					defaultDAppName={defaultDAppName}
					isOpen={isNewSmartContractModalOpen.value}
					onClose={() => setSmartContractModalState(false)}
				/>
			)}
		</>
	)
}

export { SmartContractMenu }
